import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * The single focus treatment for the whole system. Applied with `focus-visible`
 * so pointer users never see it, and never removed by a component.
 */
export const focusRing =
  'outline-none focus-visible:ring-2 focus-visible:ring-line-focus focus-visible:ring-offset-2 focus-visible:ring-offset-surface';

/** Focus ring for controls sitting on the navy rail or a coloured fill. */
export const focusRingInverse =
  'outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-navy';
